import { render } from "./SiteVerticalNavigation.vue?vue&type=template&id=748404f0&scoped=true&ts=true"
import script from "./SiteVerticalNavigation.vue?vue&type=script&lang=ts"
export * from "./SiteVerticalNavigation.vue?vue&type=script&lang=ts"

import "./SiteVerticalNavigation.vue?vue&type=style&index=0&id=748404f0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748404f0"]])

export default __exports__